import React, { 
  useContext, useEffect, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'; 
import { Button, ButtonGroup } from '@/shared/components/Button';
import { 
  Pagination, Modal, Form, InputGroup, 
} from 'react-bootstrap';
import { FaExclamationCircle } from 'react-icons/fa';
import PendingCard from './PendingCard';
import Loading from '../../../../../shared/components/Loading';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';
import { AuthContext } from '../../../../../context/AuthContext';

const Pending = ({ restaurantid }) => {
  const { apiGlobal } = useContext(GlobalVarContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const { countryId } = useContext(AuthContext);
  const [bookingData, setBookingData] = useState([]);
  const [filteredBookingData, setFilteredBookingData] = useState({});
  const [paxDetailsHandler, setPaxDetailsHandler] = useState([]);
  const [tripOption, setTripOption] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [TripData, setTripData] = useState([]);
    // Search filter states
    const [searchTripName, setSearchTripName] = useState('');
    const [searchStartDate, setSearchStartDate] = useState('');
    const [searchEndDate, setSearchEndDate] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;

    
 const isMounted = useRef(true);
    const fetchBookingData = async () => {
      const formData = new FormData();
      formData.append('restaurant_id', restaurantid);
      formData.append('country_id', countryId);
      try {
         const url = await fetch(`${apiGlobal}/restaurant/booking_pending_list.php`, {
          method: 'POST',
          body: formData,
         });
         const response = await url.json();
        // console.log(response);
         if (response?.status && response?.message) {
          setBookingData(response?.data);
          setFilteredBookingData(response?.data);
          const tripOptions = response?.data.map(trip => ({
            value: trip?.id,
            label: trip?.name, 
          }));
          setTripOption(tripOptions);
           setIsLoading(false);
         } else {
          setBookingData({});
          setIsLoading(false);
         }
      } catch (error) {
        console.error(error);
      }
    };

    // const isMounted = useRef(true);
    // const CACHE_TTL = 60 * 1000; // 1 minute TTL (in milliseconds)
  
    // const fetchBookingData = async () => {
    //   try {
    //     const cacheName = 'BookingCache';
    //     const cache = await caches.open(cacheName);
        
    //     // Construct cacheKey using agentId
    //     const cacheKey = `${apiGlobal}/restaurant/booking_pending_list.php?restaurant_id=${restaurantid}`;
    //     const cachedResponse = await cache.match(cacheKey);
    //     const currentTime = new Date().getTime(); // Current timestamp in milliseconds
    
    //     if (cachedResponse) {
    //       const cachedData = await cachedResponse.json();
    //       const { cachedAt } = cachedData;
    
    //       // If cached data is valid (not expired), use it
    //       if (currentTime - cachedAt < CACHE_TTL) {
    //         console.log('Using cached data');
    //         setBookingData(cachedData?.data);
    //         setFilteredBookingData(cachedData?.data); // Initial setting of filtered data
    //         const tripOptions = cachedData?.data?.map(trip => ({
    //           value: trip?.id,
    //           label: `${trip?.name} (${trip?.trip_uin})`, 
    //         }));
    //         setTripOption(tripOptions);
    //         setIsLoading(false);
    //         return; // Return early if cache is valid
    //       }
    
    //       console.log('Cache expired, fetching new data');
    //       await cache.delete(cacheKey); // Delete expired cache
    //     }
    
    //     // Fetch new data from API if no valid cache
    //     const url = await fetch(`${apiGlobal}/restaurant/booking_pending_list.php?restaurant_id=${restaurantid}`);
    //     const response = await url.json();
    
    //     if (response?.status && response?.message) {
    //       if (isMounted.current) {
    //         setBookingData(response?.data);
    //         setFilteredBookingData(response?.data); // Initial setting of filtered data
    //         const tripOptions = response?.data?.map(trip => ({
    //           value: trip?.id,
    //           label: `${trip?.name} (${trip?.trip_uin})`, 
    //         }));
    //         setTripOption(tripOptions);
    //         setIsLoading(false);
    
    //         // Add TTL information to the data before caching
    //         const dataWithTTL = {
    //           data: response?.data,
    //           cachedAt: currentTime, // Store the time when the data was cached
    //         };
    
    //         // Cache the new response for future use
    //         await cache.put(cacheKey, new Response(JSON.stringify(dataWithTTL)));
    //       }
    //     } else if (isMounted.current) {
    //       setBookingData([]);
    //       setIsLoading(false);
    //     }
    //   } catch (error) {
    //     console.error(error);
    //     setIsLoading(false);
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };
    
  
    useEffect(() => {
      isMounted.current = true;
      fetchBookingData();
  
      // // Set interval to refresh data every 1 minute
      // const intervalId = setInterval(fetchBookingData, 60000); // 60000ms = 1 minute
  
      return () => {
        isMounted.current = false;
        // clearInterval(intervalId);
      };
    }, [restaurantid, refresh, sideBarRefresh?.restaurantBookingRefresh]); // Re-run fetch if agentId or refresh changes

    // useEffect(() => {
    //   fetchBookingData();
    // }, [restaurantid, refresh]);

    const filterBookingHandler = (selectedOption) => {
      setSelectedTrip(selectedOption); // Update selected trip
    
      if (!selectedOption) {
        setFilteredBookingData(bookingData); // Reset filter when no trip is selected
        return;
      }
    
      // Filter booking data based on selected trip ID
      const filteredData = bookingData.filter(trip => trip?.id === selectedOption.value);
      setFilteredBookingData(filteredData);
    };

    // Handle page change
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
  
    // Pagination Logic - Slice data for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = bookingData.slice(indexOfFirstItem, indexOfLastItem);
  
    // Total pages
    const totalPages = Math.ceil(bookingData.length / itemsPerPage);

 
   // Filter Data Based on Date Range
   useEffect(() => {
     let filteredData = [...bookingData];
 
     if (searchStartDate) {
       filteredData = filteredData.filter((trip) => {
         const tripStartDate = new Date(trip?.start_date);
         return tripStartDate >= new Date(searchStartDate);
       });
     }
 
     if (searchEndDate) {
       filteredData = filteredData.filter((trip) => {
         const tripEndDate = new Date(trip?.end_date);
         return tripEndDate <= new Date(searchEndDate);
       });
     }
 
     setFilteredBookingData(filteredData);
   }, [searchStartDate, searchEndDate, bookingData]);
 

  return (
    <div>
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px', // Add gap between the input fields
          alignItems: 'center', // Vertically align input fields and button
          flexWrap: 'nowrap', // Make sure the filters stay in a single line
        }}
      >
        {/* <h5
          className="mb-2"
          style={{
            color: '#495057',
            alignSelf: 'center',
            marginRight: '20px',
            fontWeight: '600',
          }}
        >
          Filter Trips
        </h5> */}

        {/* <InputGroup className="mb-2" style={{ maxWidth: '200px' }}>
          <Form.Control
            type="text"
            placeholder="Search by Trip Name"
            value={searchTripName}
            onChange={e => setSearchTripName(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup> */}
        <Select
          name="tripName"
          className="react-select w-25 mb-4 mt-3"
          classNamePrefix="react-select"
          options={tripOption}
          isClearable
          value={selectedTrip}
          placeholder="Select a trip"
          onChange={filterBookingHandler}
        />
        {/* Search Filters */}
        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchStartDate}
            onChange={e => setSearchStartDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="End Date"
            value={searchEndDate}
            onChange={e => setSearchEndDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchTripName('');
            setSearchStartDate('');
            setSearchEndDate('');
          }}
        >
          Clear Filters
        </Button>
        {/* <Button
          variant="outline-primary"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => setShowAddModal(true)}
        >
          Add Trip
        </Button> */}
      </div>

      <div>
        {filteredBookingData.length > 0 ? (
        filteredBookingData.map(booking => (
          <PendingCard 
            key={booking?.id}
            bookingData={booking}
            paxDetailsHandler={paxDetailsHandler}
            setPaxDetailsHandler={setPaxDetailsHandler}
            setRefresh={setRefresh}
          />
        ))
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '50px',
          backgroundColor: '#f8d7da',
          borderRadius: '8px',
          marginTop: '20px',
          color: '#721c24',
          fontSize: '16px',
          }}
        >
          <div
            style={{
            fontSize: '48px',
            marginBottom: '20px',
            color: '#e63946',
            animation: 'pulse 1.5s infinite ease-in-out',
            display: 'inline-block',
          }}
          >
            <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
          </div>
          <p>No Pending booking available</p>
        </div>
)}
      </div>
      {/* Pagination Controls */}
      <div style={{
        float: 'right',
        bottom: '20px', 
        right: '20px', 
        zIndex: 999, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
}}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </div>
    );
}; 

Pending.propTypes = {
  restaurantid: PropTypes.string.isRequired,

};

export default Pending;
